import { createContext } from 'react';
import { ApiContextType } from 'types/ApiProvider.types';

/**
 * Api Context
 *
 * This context provides:
 * - API clients
 * - Initialization status
 * - Initialization error
 *
 * The default values represent the unauthenticated state with
 * loading in progress and empty implementation of auth methods.
 */
const ApiContext = createContext<ApiContextType>({
  apiClients: null,
  isInitialized: false,
  initError: null,
});

export default ApiContext;
